@if (destination) {
<div class="full-width destination">
  <div class="title">
    <p class="upper">Destinations</p>
    <h1>{{ destination.country }}</h1>
  </div>
  <div class="cover-wrapper">
    <img
      id="timg"
      alt="destination-cover"
      class="full-width"
      [ngSrc]="destination.coverPicture.src"
      fill
      priority
    />
  </div>
  <div class="separator">
    <span></span>
  </div>
</div>
<div
  class="description w-8 m-auto"
  [class.w-8]="deviceService.isTablet()"
  [class.w-10]="deviceService.isMobile()"
>
  <app-inner-html [content]="destination.description"></app-inner-html>
</div>
<div
  class="articles row container m-auto"
  appLazyLoad
  (load)="getArticles()"
  [(loading)]="loading"
  [end]="endLazyLoading"
>
  @if (deviceService.isMobile()) {
  <div class="column w-12">
    <app-article-card *ngFor="let article of articles" [article]="article" class="column-article">
    </app-article-card>
    @if(loading) {
    <app-article-card-loading class="full-width" class="column-article"></app-article-card-loading>
    }
  </div>
  } @else {
  <div class="article-container">
    <app-article-card *ngFor="let article of articles" [article]="article" class="w-6 article">
    </app-article-card>
    <app-article-card-loading class="article" *ngIf="loading"></app-article-card-loading>
  </div>

  }
  <div #detector></div>
</div>
<div class="full-width destinations">
  <div class="container m-auto">
    <div class="w-10 m-auto">
      <div class="other-destinations">Partir vers d'autres destinations</div>
      @for (destination of destinations; let i = $index; track $index) {
      <section
        class="destination-line"
        [class.disabled]="deviceService.isMobileOrTablet()"
        [@destinationAnimation]="hoverDestinations[destination.id] ? 'onHover' : 'onHide'"
        (mouseenter)="hoverDestination(destination.id, true)"
        (mouseleave)="hoverDestination(destination.id, false)"
        (click)="navigateToDestination(destination.country)"
      >
        <div class="destination-name">{{ destination.country }}</div>
        <div class="number">{{ i + 1 | number : '2.0-0' }}</div>
        <div
          class="image-container"
          [@destinationImageAnimation]="hoverDestinations[destination.id] ? 'onHover' : 'onHide'"
        >
          <img loading="lazy" [ngSrc]="destination.coverPicture.src" alt="destination" fill />
        </div>
      </section>
      }
    </div>
  </div>
</div>
}
